import createIcon from '@/lib/create-icon'

const GolfIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M16.9265 31.9614C12.0645 32.6925 8.66675 34.4866 8.66675 36.4292C8.66675 39.0456 14.8301 41.1666 22.433 41.1666C30.0358 41.1666 36.1992 39.0456 36.1992 36.4292C36.1992 34.3665 32.3685 32.6117 27.0216 31.9614'
      stroke='url(#paint0_linear_5307_2486)'
      strokeWidth='2.75869'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M16.9265 31.9614C12.0645 32.6925 8.66675 34.4866 8.66675 36.4292C8.66675 39.0456 14.8301 41.1666 22.433 41.1666C30.0358 41.1666 36.1992 39.0456 36.1992 36.4292C36.1992 34.3665 32.3685 32.6117 27.0216 31.9614'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.75869'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M16.9265 31.9614C12.0645 32.6925 8.66675 34.4866 8.66675 36.4292C8.66675 39.0456 14.8301 41.1666 22.433 41.1666C30.0358 41.1666 36.1992 39.0456 36.1992 36.4292C36.1992 34.3665 32.3685 32.6117 27.0216 31.9614'
      stroke='url(#paint1_radial_5307_2486)'
      strokeOpacity='0.6'
      strokeWidth='2.75869'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M21.5042 35.7003C21.6563 22.5061 21.1406 10.1548 21.8183 6.01797C22.3327 4.5525 23.2366 3.08673 29.1702 6.3391L33.1808 8.30438C35.6486 9.51368 39.0833 11.4417 37.6701 13.7987C37.027 14.8714 35.5628 16.0697 32.7041 17.288L21.5003 22.7451'
      stroke='url(#paint2_linear_5307_2486)'
      strokeWidth='2.75869'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M21.5042 35.7003C21.6563 22.5061 21.1406 10.1548 21.8183 6.01797C22.3327 4.5525 23.2366 3.08673 29.1702 6.3391L33.1808 8.30438C35.6486 9.51368 39.0833 11.4417 37.6701 13.7987C37.027 14.8714 35.5628 16.0697 32.7041 17.288L21.5003 22.7451'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.75869'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M21.5042 35.7003C21.6563 22.5061 21.1406 10.1548 21.8183 6.01797C22.3327 4.5525 23.2366 3.08673 29.1702 6.3391L33.1808 8.30438C35.6486 9.51368 39.0833 11.4417 37.6701 13.7987C37.027 14.8714 35.5628 16.0697 32.7041 17.288L21.5003 22.7451'
      stroke='url(#paint3_radial_5307_2486)'
      strokeOpacity='0.6'
      strokeWidth='2.75869'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5307_2486'
        x1='8.66675'
        y1='31.9614'
        x2='17.4456'
        y2='50.1956'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5307_2486'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.433 41.1666) scale(13.7662 4.68763)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5307_2486'
        x1='21.458'
        y1='4.38428'
        x2='46.1631'
        y2='13.4467'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5307_2486'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(29.729 35.7003) scale(8.27098 15.9473)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'GolfIcon'
)

export default GolfIcon
